import HTTP from '../../services/http';

let bodyOverflow;

function close() {
  const container = document.getElementById('arbor_customer_features_container');
  if (container) {
    container.parentNode.removeChild(container);
  }
  document.body.style.overflow = bodyOverflow || null;
}
async function displayResults(msg) {
  let messageText1 = '';
  let messageText2 = '';

  const loc = document.location.pathname;

  const root = document.getElementById('root') || document.body;
  const x = [];
  const sorted_keys = Object.keys(msg).sort((a, b) => a.localeCompare(b));

  sorted_keys.forEach(key => x.push(`<div>${key}: ${msg?.[key]}</div>`));
  const sorted_and_spaced = [];
  let i = x[0].toLowerCase().charCodeAt(5);
  x.forEach(entry => {
    if (entry.toLowerCase().charCodeAt(5) > i) {
      sorted_and_spaced.push('<br>');
      i = entry.toLowerCase().charCodeAt(5);
    }
    sorted_and_spaced.push(entry);
  });
  const count = sorted_and_spaced.length;
  const column1_count = Math.round(count / 2);
  messageText1 = sorted_and_spaced.slice(0, column1_count).join('');
  messageText2 = sorted_and_spaced.slice(column1_count).join('');
  let container = document.getElementById('arbor_customer_features_container');

  const mask_style = {
    'overflow': 'hidden',
    'position': 'fixed',
    'top': 0,
    'left': 0,
    'opacity': 0.75,
    'z-index': 99999,
    'height': '100%',
    'width': '100%',
    'background': '#999',
  };
  const mask_style_array = [];
  Object.entries(mask_style).forEach(([key, value]) => mask_style_array.push(`${key}:${value}`));
  const mask_style_string = mask_style_array.join(';');
  const outer_style = {
    'z-index': 50000,
    'position': 'fixed',
    'top': '50px',
    'left': 0,
    'right': 0,
  };
  const outer_style_array = [];
  Object.entries(outer_style).forEach(([key, value]) => {
    outer_style_array.push(`${key}:${value}`);
  });
  const outer_style_string = outer_style_array.join(';');
  if (!container) {
    root.insertAdjacentHTML(
      'afterend',
      `<div id="arbor_customer_features_container" style="${outer_style_string}"></div>`,
    );
  }
  container = document.getElementById('arbor_customer_features_container');
  container.insertAdjacentHTML('afterbegin', `<div style="${mask_style_string}"></div>`);
  const box1_style = {
    'z-index': 100000,
    'color': 'black',
    'padding': '10px',
    'background': '#eef4f9',
    'opacity': 1,
    'white-space': 'nowrap',
    'position': 'absolute',
    'top': '10%',
    'left': '30%',
    'width': 'auto',
    'transform': 'translateX(-50%)',
    'height': 'auto',
    'border': '2px black solid',
    'border-radius': '6px',
    'font-size': '16px',
    'line-height': '22px',
  };
  const box1_style_array = [];
  Object.entries(box1_style).forEach(([key, value]) => box1_style_array.push(`${key}:${value}`));
  const box1_style_string = box1_style_array.join(';');
  const box2_style = {
    'z-index': 100000,
    'color': 'black',
    'padding': '10px',
    'background': '#eef4f9',
    'opacity': 1,
    'white-space': 'nowrap',
    'position': 'absolute',
    'top': '10%',
    'left': '70%',
    'width': 'auto',
    'transform': 'translateX(-50%)',
    'height': 'auto',
    'border': '2px black solid',
    'border-radius': '6px',
    'font-size': '16px',
    'line-height': '22px',
  };
  const box2_style_array = [];
  Object.entries(box2_style).forEach(([key, value]) => box2_style_array.push(`${key}:${value}`));
  const box2_style_string = box2_style_array.join(';');
  container.insertAdjacentHTML(
    'afterbegin',
    `<div style="${box1_style_string}">${messageText1}</div><div style="${box2_style_string}">${messageText2}</div>`,
  );
  const close_button = document.getElementById('arbor_customer_features_container');

  close_button.addEventListener('click', () => close());

  bodyOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
}

async function getFlags() {
  const protocol = window.location.href.split('//')[0];
  const servicesHost = window.location.href.split('//')[1].split('/')[0];
  const featuresUrl = `${protocol}//${servicesHost}/api/config/features`;
  const features_request = await HTTP.get(featuresUrl);
  console.log('features_request: ', features_request);
  displayResults(features_request.data);
}

export default getFlags;
